//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Autosize from 'autosize' // prop.autosize
import mixinComponent from './mixinComponent.js'
export default {
  name: 'VyTextarea',
  mixins: [mixinComponent],
  props: {
    title: String,
    inlineDesc: String,
    showCounter: {type: Boolean, default: true},
    max: Number,
    value: String,
    name: String,
    placeholder: String,
    required: Boolean,
    readonly: Boolean,
    disabled: Boolean,
    rows: {type: Number, default: 3},
    cols: {type: Number, default: 30},
    height: Number,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {type: String, default: 'off'},
    autocapitalize: {type: String, default: 'off'},
    autocorrect: {type: String, default: 'off'},
    spellcheck: {type: String, default: 'false'},
    autosize: Boolean, // prop.autosize
  },
  data () {
    return {
      hasRestrictedLabel: false,
      currentValue: this.value,
      isFocus: false,
    }
  },
  computed: {
    count () {
      let len = 0
      if(this.currentValue) {
        len = this.currentValue.replace(/\n/g, 'aa').length
      }
      return len > this.max ? this.max : len
    },
    textareaStyle () {
      if(this.height) {
        return {
          height: `${this.height}px`,
        }
      }
    },
    labelStyles () {
      return {
        width: this.$parent.labelWidth || this.labelWidth + 'em',
        textAlign: this.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight,
      }
    },
    labelWidth () {
      return this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1
    },
    labelClass () {
      return {
        'vux-cell-justify':
          this.$parent.labelAlign === 'justify' ||
          this.$parent.$parent.labelAlign === 'justify',
      }
    },
  },
  watch: {
    // prop.autosize
    autosize (val) {
      this.unbindAutosize()
      if(val) {
        this.bindAutosize()
      }
    },
    // prop.autosize
    value (val) {
      this.currentValue = val
    },
    currentValue (newVal) {
      if(this.max && newVal && newVal.length > this.max) {
        this.currentValue = newVal.slice(0, this.max)
      }
      this.$emit('input', this.currentValue)
      this.$emit('on-change', this.currentValue)
    },
  },
  mounted () {
    if(this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true
    }
    // prop.autosize
    this.$nextTick(() => {
      if(this.autosize) {
        this.bindAutosize()
      }
    })
    // prop.autosize
  },
  // prop.autosize
  beforeDestroy () {
    this.unbindAutosize()
  },
  // prop.autosize
  methods: {
    updateAutosize () {
      Autosize.update(this.$refs.textarea)
    },
    // prop.autosize
    bindAutosize () {
      Autosize(this.$refs.textarea)
    },
    unbindAutosize () {
      Autosize.destroy(this.$refs.textarea)
    },
    // prop.autosize
    focus () {
      this.$refs.textarea.focus()
    },
    onFocus ($event) {
      this.isFocus = true
      this.$emit('on-focus', this.fieldKey, this.currentValue, $event)
    },
    onBlur ($event) {
      this.isFocus = false
      this.$emit('on-blur', this.fieldKey, this.currentValue, $event)
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/basic/VyInputTextarea.vue